<template>
    <div class="homeWorkPResultPage">
        <!--作业发布结果页面-->
        <div>
            <el-button type="text" size="medium" class="text-default-color text-s-size" @click="$router.back()">
                < 返回
            </el-button>
            <span class="text-s-size text-l-secondary">|</span>
            <el-divider></el-divider>
        </div>
        <div class="text-center centerContent">
            <div class="titleS">
                <span class="el-icon-success"></span> 成功布置作业
            </div>
            <div class="buttonAlign">
                <el-button class="rounded-medium lookJl" size="small" @click="$router.push('/teacher/homework/records')">查看作业记录</el-button>
                <el-button class="rounded-medium continue" type="primary" size="small" @click="$router.back()">继续布置</el-button>
            </div>
            <div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../../../assets/static/global/event-bus";
    export default {
        name: "homeWorkPResultPage",
        beforeDestroy() {
            EventBus.$emit('homePickTitle','作业资源库');
        }
    }
</script>

<style lang="scss" scoped>
    .homeWorkPResultPage{
        .centerContent{
            margin-top:200px;
            margin-bottom: 200px;
        }
        .titleS{
            span{
                vertical-align: middle;
               font-size: 29px;
            }
            font-size:23px;
            color: #67E296;
            margin-bottom: 20px;
        }
        .buttonAlign{
            .lookJl{
                 border:1px solid dodgerblue;
                 color: dodgerblue;
            }
            .continue{
                background:#0a93fc;
                color: #ffffff;
            }
        }
    }
</style>